import {Component, inject, OnInit} from '@angular/core';
import {DecimalPipe, NgForOf, NgIf} from "@angular/common";
import {NgbPagination} from "@ng-bootstrap/ng-bootstrap";
import {NotFoundComponent} from "../../shared/not-found/not-found.component";
import {MasterPlantDto, MasterPlantSearchParam, Page} from '../../../generated-model/model';
import {FormsModule, ReactiveFormsModule} from "@angular/forms";
import {GtNgDatepickerModule} from '../../shared/gt-ng-datepicker/gt-ng-datepicker.module';
import {MasterPlantRest} from '../../service/MasterPlantRest';
import {IgnoreNullHttpParams} from '../../shared/Ignore-null-http-params';
import {filter} from 'rxjs/operators';
import {
  QrTraceTypeAutocompleteComponent
} from '../../shared/components/qrtracetype-autocomplete/qrtracetype-autocomplete.component';
import {
  ProductGroupDetailComponent
} from '../../shared/components/product-group-detail-autocomplete/product-group-detail.component';

@Component({
  selector: 'app-search',
  standalone: true,
  imports: [
    DecimalPipe,
    NgForOf,
    NgIf,
    NgbPagination,
    NotFoundComponent,
    ReactiveFormsModule,
    GtNgDatepickerModule,
    QrTraceTypeAutocompleteComponent,
    FormsModule,
    ProductGroupDetailComponent
  ],
  templateUrl: './search.component.html',
  styleUrl: './search.component.scss'
})
export class SearchComponent implements OnInit{
  pageData: Page<MasterPlantDto> = {size: 10};
  masterPlantService = inject(MasterPlantRest)
  searchParam: MasterPlantSearchParam = {}

  ngOnInit(): void {
    this.search()
  }

  search(page: number = 1) {
    let param = IgnoreNullHttpParams.fromObject({...this.searchParam})
      .set('size' , this.pageData.size)
      .set('page' , page - 1)
    this.masterPlantService.searchPlantWithManufacturerPublicTrue(param).pipe(filter(e => !!e)).subscribe({
      next:e => {
        this.pageData = e
      }
    })
  }

  clear() {
    this.searchParam = {}
    this.search()
  }
  onchangeType() {
    this.searchParam.category = undefined
  }
}
